import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { toast } from 'react-toastify';
import { vendorUrlRegexPath, withMcURL } from 'src/helpers/service';
import { IBestSellingProductsResponse } from './types';

interface IBestSellingProductsParams {
  page?: number;
  limit?: number;
}

export const useBestSellingProducts = (params: IBestSellingProductsParams = {}) => {
  const page = params.page ?? 1;
  const limit = params.limit ?? 20;

  const fetchBestSellingProducts = async () => {
    const res = await axios.get<IBestSellingProductsResponse>(
      withMcURL(vendorUrlRegexPath('vendor/:vendorId/bi-suggest-vendor-product')),
      { params: { page, limit } }
    );
    return res.data;
  };

  return useQuery(['best-selling-products', page, limit], fetchBestSellingProducts, {
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 3,
  });
};

export const useClickToSellFastListing = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (productIds: number[]) => {
      const res = await axios.post(withMcURL(vendorUrlRegexPath('vendor/:vendorId/click-to-sell/fast-listing')), {
        productIds,
      });
      return res.data;
    },
    onSuccess: () => {
      toast.success('Seçilen ürünler başarıyla gönderildi.');
      queryClient.invalidateQueries(['best-selling-products']);
    },
    onError: (err: any) => {
      toast.error(err?.response?.data?.detail || err?.response?.data?.message || err?.message || 'Ürünler gönderilemedi.');
    },
  });
};
